import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@mui/material/Grid2";
import { useShowDebugValues } from "@plansoft-configuration-renderer/debug";
import { AttributeValueContentType } from "./AttributeValueContentType";
import { ValueContentDebug } from "./ValueContent";
import { ValueContentMultiple } from "./ValueContentMultiple";
const template = [
    AttributeValueContentType.Value,
    AttributeValueContentType.TypeCode,
    AttributeValueContentType.ItemNo,
    AttributeValueContentType.Price,
    AttributeValueContentType.Suggestion,
    AttributeValueContentType.Help,
];
/**
 * Fallback value template for configuration values
 * - rendered if no layout is specified as a part of fallback rendering strategy
 * @returns
 */
export function DefaultValueTemplate() {
    const showDebug = useShowDebugValues();
    return (_jsxs(Grid, { container: true, sx: {
            justifyContent: "space-between",
        }, children: [_jsx(Grid, { children: _jsx(ValueContentMultiple, { template: template, separator: "▪", separatorColor: "primary" }) }), showDebug && (_jsx(Grid, { children: _jsx(ValueContentDebug, {}) }))] }));
}
//# sourceMappingURL=DefaultValueTemplate.js.map